// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","ly_tooltip_wrapper":"_0Fpubg","AniFadeIn":"R_Y6N4","AniFadeOut":"_74kQBU","AniRotate":"DB8a5M","AniPlaceholderFadeOut":"_jpRz2"};